export default __webpack_public_path__ + "0c16681a6029879ffa941e1bb8930aeb.png";